import { useDashboardState } from "components/DashboardContext";

export default function CommonParameterSection({ commonParameterObject }) {

    const { getLabelByIsTranslateModelEnabled } = useDashboardState()

    return (
        <section className="custom-parameter-section" onClick={(e) => { e.stopPropagation() }}>
            <div className="custom-parameter-name">
                {getLabelByIsTranslateModelEnabled(commonParameterObject.name)}
            </div>
            <div className="custom-parameter-value">
                {typeof (commonParameterObject.value) === 'number' ?
                    Math.round(commonParameterObject.value * 100) /100
                    :
                    commonParameterObject.value}
            </div>
        </section>
    )
}
